import React, { useEffect, useRef } from 'react';

import { initPartnersCarousel } from './patnerscarosel';

type Props = {
  direction?: 'left' | 'right';
  speedSeconds?: number;
};

const PARTNER_IMAGES: readonly string[] = [
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT25c4tA75YsZSYcT00jj5GSMWXJSS3CK5gmQ&s',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTe7APeoKgaAS9RiS9Q18_UtDqJeZ3ZtOrr5g&s',
  'https://www.zse.co.zw/wp-content/uploads/2019/03/national-foods-57.jpg',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdPf_kUXt8orhOmAFNuFCsQi4GwKrGE3IIqQ&s',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRw9SmX7Xl_InpIWrdaE9sN3L9WHMdcyAS2IA&s',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-LSylp_tphxFwxhOd_h85hVpCGV4dfJcDxw&s',
];

export default function PartnersCarousel({
  direction = 'left',
  speedSeconds = 12,
}: Props): React.ReactElement {
  const trackRef = useRef<HTMLDivElement | null>(null);
  const items = PARTNER_IMAGES;

  useEffect(() => {
    return initPartnersCarousel(trackRef.current, {
      direction,
      speedSeconds,
    });
  }, [direction, speedSeconds]);

  return (
    <section className="bg-white">
      <div className="w-full py-12">
        <div className="relative w-full overflow-hidden">
          <div
            ref={trackRef}
            className="ae-marquee-track"
          >
            {items.map((src, idx) => (
              <div key={`${src}-${idx}`} className="ae-marquee-item">
                <img
                  src={src}
                  alt="Business partner logo"
                  loading="lazy"
                  className="h-14 w-auto object-contain sm:h-16"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
